import { Container } from "react-bootstrap";
import { Route, Switch, useRouteMatch } from "react-router";
import EditRole from "./EditRole";
import ListRole from "./ListRole";

function RolesIndex(){
    let {path, url} = useRouteMatch();

    return(
        <Container fluid className="my-5">
            <Switch>
                <Route exact path={path}><ListRole url={url}/></Route>
                <Route exact path={`${path}/:id`}><EditRole /></Route>
            </Switch>            
        </Container>
    )

    
}

export default RolesIndex